<template>
  <div class="position-relative">
    <b-form-input
      v-model="value"
      @keyup="keyUp(value)"
      size="sm"
      class="form-control"
      placeholder="جستجو"
    >
    </b-form-input>
    <span v-if="value" class="clear" @click="clear">
      <i class="fas fa-times"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: "search-input-component",
  data() {
    return {
      value: "",
    };
  },

  methods: {
    keyUp() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.search , 700)
    },

    search() {
      this.$store.dispatch("setQueryFilter", this.value);
    },
    clear() {
      this.value = "";
      this.$store.dispatch("setQueryFilter", null);
    },
    timeout:null,
  },
};
</script>

<style lang="scss">
.clear {
  position: absolute;
  left: 8px;
  top: 7px;
  color: #7f7f7f;
  cursor: pointer;
}
</style>

